import { render } from "./BaseSingleLayout.vue?vue&type=template&id=7a5f659a"
import script from "./BaseSingleLayout.vue?vue&type=script&lang=js"
export * from "./BaseSingleLayout.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__